import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function NoMeetingRoomIcon(props: IconProps) {
    return <Icon {...props} iconKey={"no_meeting_room"}/>
}
